import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { LoHangMuaBan } from './LoHangMuaBan.model';
import { BaseService } from './Base.service';
@Injectable({
    providedIn: 'root'
})
export class LoHangMuaBanService extends BaseService{

    DisplayColumns001: string[] = ['STT', 'ID', 'Display', 'Name', 'CCCD', 'DienThoai', 'Save'];
    DisplayColumns002: string[] = ['STT', 'ID', 'DanhMucPhuongThucMuaBanID', 'NgayGhiNhan', 'DonGia', 'Display', 'Name', 'DienThoai', 'Note', 'Save'];
    DisplayColumns003: string[] = ['STT', 'ID', 'ToChucID', 'ParentID', 'DanhMucPhuongThucMuaBanID', 'NgayGhiNhan', 'DonGia', 'Display', 'Name', 'DienThoai', 'Note', 'Save'];

    List: LoHangMuaBan[] | undefined;
    ListFilter: LoHangMuaBan[] | undefined;
    FormData!: LoHangMuaBan;

    constructor(public httpClient: HttpClient) {
        super(httpClient);
        this.Controller = "LoHangMuaBan";
    }

    GetByToChucIDAndEmptyToListAsync() {
        let url = this.APIURL + this.Controller + '/GetByToChucIDAndEmptyToListAsync';
        const formUpload: FormData = new FormData();
        formUpload.append('data', JSON.stringify(this.BaseParameter));
        return this.httpClient.post(url, formUpload, { headers: this.Headers });
    }
}

